import { Component, Input, HostBinding, HostListener } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[collapse]',
  template: '<ng-content></ng-content>',
  animations: [
    trigger('collapse', [
      state(
        'false',
        style({ height: '0', opacity: '0', visibility: 'hidden' }),
      ),
      state('true', style({ height: '*', opacity: '1', visibility: '*' })),
      transition('true <=> false', animate('{{duration}}ms {{easing}}'), {
        params: {
          duration: 350,
          easing: 'ease-in-out',
        },
      }),
    ]),
  ],
  standalone: true,
})
export class CollapseComponent {
  @HostBinding('@collapse')
  @Input()
  collapse: boolean = true;
}
